<!-- BEGIN #sidebar -->
<div id="sidebar" class="app-sidebar" [attr.data-bs-theme]="sidebarTheme()" [ngClass]="{ 
	'app-sidebar-transparent': this.appSidebarTransparent() && !appSettings.isMobile(),
	'app-sidebar-grid': this.appSidebarGrid()
}">
  <!-- BEGIN scrollbar -->
  <div class="app-sidebar-content" [class.h-100]="appSettings.appSidebarFixed" #sidebarScrollbar
    (scroll)="onScroll($event)">
    <ng-container *ngTemplateOutlet="sidebarNav"></ng-container>
  </div>
  <!-- END scrollbar -->

  <ng-template #sidebarNav>
    <!-- BEGIN menu -->
    <div class="menu">
      <div class="menu-item menu-profile">
        <div class="menu-profile-cover custom-shadow"></div>
        <div class="menu-profile-info">
          @if (appSettings.isMobile()) {
            <div class="mobile-profile">
              <div class="mobile-profile-avatar">
                @if (userPhoto()) {
                  <img [src]="userPhoto()" alt="">
                } @else {
                  <span>{{ userInitials() }}</span>
                }
              </div>
              <div class="mobile-profile-text">
                <div class="mobile-profile-name">{{ userData()?.displayName || 'Mi perfil' }}</div>
                <div class="mobile-profile-role">
                  {{ activeRole()?.displayName || activeRole()?.description || activeRole()?.name || 'Rol' }}
                  · Rol activo
                </div>
              </div>
            </div>
          } @else if (activeRole(); as role) {
            <div class="d-flex align-items-center mb-2">
              <div class="flex-grow-1 ">
                <span>{{ role?.displayName || role?.description || role?.name }}</span>
              </div>
            </div>
            <small class="mt-1">Rol activo</small>
          }
        </div>
      </div>

      <div class="menu-header">Navegación</div>

      <!-- render sidebarMenuNav -->
      <ng-template #sidebarMenuNav let-menu="menu">
        <div class="menu-icon-img" *ngIf="menu.img"><img src="{{ menu.img }}" /></div>
        <div class="menu-icon" *ngIf="menu.icon"><i class="{{ menu.icon }}"></i></div>
        <div class="menu-text" *ngIf="menu.title">
          {{ menu.title }}
          <span class="menu-label" *ngIf="menu.label">{{ menu.label }}</span>
        </div>
        <div class="menu-badge" *ngIf="menu.badge">{{ menu.badge }}</div>
        <div class="menu-caret" *ngIf="menu.caret"></div>
      </ng-template>

      <!-- render sidebarSubMenuNav -->
      <ng-template #sidebarSubMenuNav let-menu="menu">
        <div class="menu-text" *ngIf="menu.title">
          {{ menu.title }}
          <i class="fa fa-paper-plane text-theme ms-5px" *ngIf="menu.highlight"></i>
        </div>
        <div class="menu-caret" *ngIf="menu.caret"></div>
      </ng-template>

      <!-- sidebar menu -->
      @for(menu of menus();track menu.title){
      <div class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
        [ngClass]="{ 'expand': isSubmenuOpen(menu, rla.isActive), 'closed': menu.state == 'collapse', 'has-sub': menu.submenu?.length > 0, 'd-none': menu.hide }"
        #rla="routerLinkActive">

        <!-- Cuando hay submenu -->
        <a class="menu-link" *ngIf="menu.submenu?.length > 0" (click)="expandCollapseSubmenu($event, menu)"
          (mouseenter)="showAppSidebarFloatSubMenu(menu.submenu, $event)" (mouseleave)="hideAppSidebarFloatSubMenu()">
          <ng-container *ngTemplateOutlet="sidebarMenuNav; context: {menu: menu}"></ng-container>
        </a>

        <!-- Cuando no hay submenu -->
        <a class="menu-link" *ngIf="!menu.submenu?.length" [routerLink]="menuLink(menu.url)" (click)="closeMobileSidebar()">
          <ng-container *ngTemplateOutlet="sidebarMenuNav; context: {menu: menu}"></ng-container>
        </a>

        <!-- submenu lvl 1 -->
        <div class="menu-submenu" *ngIf="menu.submenu">
          @for(menu1 of menu.submenu;track menu1.title){
          <div class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
            [ngClass]="{ 'expand': isSubmenuOpen(menu1, rla1.isActive), 'closed': menu1.state == 'collapse', 'has-sub': menu1.submenu?.length > 0, 'd-none': menu1.hide }"
            #rla1="routerLinkActive">
            <a class="menu-link" *ngIf="menu1.submenu?.length > 0"
              (click)="expandCollapseSubmenu($event, menu1)">
              <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu1}"></ng-template>
            </a>
            <a class="menu-link" *ngIf="!menu1.submenu?.length" [routerLink]="menuLink(menu1.url)" (click)="closeMobileSidebar()">
              <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu1}"></ng-template>
            </a>

            <!-- submenu lvl 2 -->
            <div class="menu-submenu" *ngIf="menu1.submenu?.length > 0">
              <div class="menu-item" *ngFor="let menu2 of menu1.submenu" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                [ngClass]="{ 'expand': isSubmenuOpen(menu2, rla2.isActive), 'closed': menu2.state == 'collapse', 'has-sub': menu2.submenu?.length > 0, 'd-none': menu2.hide }"
                #rla2="routerLinkActive">
                <a class="menu-link" *ngIf="menu2.submenu?.length > 0"
                  (click)="expandCollapseSubmenu($event, menu2)">
                  <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu2}"></ng-template>
                </a>
                <a class="menu-link" *ngIf="!menu2.submenu?.length" [routerLink]="menuLink(menu2.url)" (click)="closeMobileSidebar()">
                  <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu2}"></ng-template>
                </a>

                <!-- submenu lvl 3 -->
                <div class="menu-submenu" *ngIf="menu2.submenu?.length > 0">
                  <div class="menu-item" *ngFor="let menu3 of menu2.submenu" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}"
                    [ngClass]="{ 'expand': isSubmenuOpen(menu3, rla3.isActive), 'closed': menu3.state == 'collapse', 'has-sub': menu3.submenu?.length > 0, 'd-none': menu3.hide }"
                    #rla3="routerLinkActive">
                    <a class="menu-link" *ngIf="menu3.submenu?.length > 0"
                      (click)="expandCollapseSubmenu($event, menu3)">
                      <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu3}"></ng-template>
                    </a>
                    <a class="menu-link" *ngIf="!menu3.submenu?.length" [routerLink]="menuLink(menu3.url)" (click)="closeMobileSidebar()">
                      <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu3}"></ng-template>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      }
    

      <!-- Opcion directa de cerrar sesion en movil -->
      <div class="menu-item d-md-none">
        <a href="javascript:;" (click)="logout()" class="menu-link text-danger">
          <div class="menu-icon text-danger"><i class="fa fa-power-off text-danger"></i></div>
          <div class="menu-text text-danger">Cerrar Sesión</div>
        </a>
      </div>

      <!-- ocultar menu-->
      <div class="menu-item d-none d-md-flex">
        <a href="javascript:;" class="app-sidebar-minify-btn ms-auto" (click)="toggleAppSidebarMinified()"><i
            class="fa fa-angle-double-left"></i></a>
      </div>

    </div>

  </ng-template>
</div>